// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ThreadButton__container-fdd1eb {
  width: auto;
  white-space: nowrap;
  box-sizing: border-box;
  cursor: pointer;
  gap: 8px;
  flex-wrap: nowrap;
  clear: both;
}

.ThreadButton__text-e3cf3e {
  font: var(--font-body-6);
  letter-spacing: var(--font-spacing-body-6);
}

.ThreadButton__icon-be24d9 {
  flex-shrink: 0;
}

.ThreadButton__icon-mention-ba5280 {
  margin-inline-start: 4px;
}

.ThreadButton__theme-1-ffb180.ThreadButton__container-fdd1eb {
  display: flex;
  align-items: center;
  height: 48px;
  padding-top: 0px;
  padding-bottom: 0px;
  padding-inline-start: 12px;
  padding-inline-end: 8px;
  border-top: 1px solid var(--base-120_08);
  background-color: inherit;
}

.ThreadButton__theme-1-ffb180 .ThreadButton__text-e3cf3e {
  color: var(--chat-bubble-primary);
  flex: 1;
}

.ThreadButton__theme-1-ffb180 .ThreadButton__icon-be24d9 {
  fill: var(--chat-bubble-primary);
}

.ThreadButton__theme-1-ffb180 .ThreadButton__icon-next-d1951e {
  fill: var(--chat-bubble-text-secondary);
  margin-inline-start: -4px;
}

.ThreadButton__theme-2-cb5ba8.ThreadButton__container-fdd1eb {
  display: inline-flex;
  align-items: center;
  align-self: flex-start;
  padding: 4px 8px;
  border-radius: 6px;
  background: linear-gradient(0deg, var(--addition-110_20), var(--addition-110_20)), linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));
}

.ThreadButton__theme-2-cb5ba8 .ThreadButton__text-e3cf3e {
  color: var(--text-on-background);
}

.ThreadButton__theme-2-cb5ba8 .ThreadButton__icon-be24d9 {
  fill: var(--text-on-background);
}

.ThreadButton__theme-2-cb5ba8 .ThreadButton__icon-thread-c2a46e {
  fill: var(--text-on-background);
}

.ThreadButton__theme-2-cb5ba8 .ThreadButton__icon-unread-fbb139 {
  background-color: var(--text-on-background);
  color: var(--accent-primary);
  font-size: 12px;
  font-weight: 700;
}

.ThreadButton__theme-2-cb5ba8 .ThreadButton__icon-next-d1951e {
  display: none;
}`, "",{"version":3,"sources":["webpack://./src/main/ChatView/Messages/Message/bubbles/components/ThreadButton/ThreadButton.styles.m.css"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,eAAA;EACA,QAAA;EACA,iBAAA;EACA,WAAA;AACF;;AAEA;EACE,wBAAA;EACA,0CAAA;AACF;;AAEA;EACE,cAAA;AACF;;AAEA;EACE,wBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,0BAAA;EACA,uBAAA;EACA,wCAAA;EACA,yBAAA;AACF;;AAEA;EACE,iCAAA;EACA,OAAA;AACF;;AAEA;EACE,gCAAA;AACF;;AAEA;EACE,uCAAA;EACA,yBAAA;AACF;;AAEA;EACE,oBAAA;EACA,mBAAA;EACA,sBAAA;EACA,gBAAA;EACA,kBAAA;EACA,wKAAA;AACF;;AAGA;EACE,gCAAA;AAAF;;AAGA;EACE,+BAAA;AAAF;;AAGA;EACE,+BAAA;AAAF;;AAGA;EACE,2CAAA;EACA,4BAAA;EACA,eAAA;EACA,gBAAA;AAAF;;AAGA;EACE,aAAA;AAAF","sourcesContent":[".container {\n  width: auto;\n  white-space: nowrap;\n  box-sizing: border-box;\n  cursor: pointer;\n  gap: 8px;\n  flex-wrap: nowrap;\n  clear: both;\n}\n\n.text {\n  font: var(--font-body-6);\n  letter-spacing: var(--font-spacing-body-6);\n}\n\n.icon {\n  flex-shrink: 0;\n}\n\n.icon-mention {\n  margin-inline-start: 4px;\n}\n\n.theme-1.container {\n  display: flex;\n  align-items: center;\n  height: 48px;\n  padding-top: 0px;\n  padding-bottom: 0px;\n  padding-inline-start: 12px;\n  padding-inline-end: 8px;\n  border-top: 1px solid var(--base-120_08);\n  background-color: inherit;\n}\n\n.theme-1 .text {\n  color: var(--chat-bubble-primary);\n  flex: 1;\n}\n\n.theme-1 .icon {\n  fill: var(--chat-bubble-primary);\n}\n\n.theme-1 .icon-next {\n  fill: var(--chat-bubble-text-secondary);\n  margin-inline-start: -4px;\n}\n\n.theme-2.container {\n  display: inline-flex;\n  align-items: center;\n  align-self: flex-start;\n  padding: 4px 8px;\n  border-radius: 6px;\n  background: linear-gradient(0deg, var(--addition-110_20), var(--addition-110_20)),\n    linear-gradient(0deg, var(--chat-background-average), var(--chat-background-average));\n}\n\n.theme-2 .text {\n  color: var(--text-on-background);\n}\n\n.theme-2 .icon {\n  fill: var(--text-on-background);\n}\n\n.theme-2 .icon-thread {\n  fill: var(--text-on-background);\n}\n\n.theme-2 .icon-unread {\n  background-color: var(--text-on-background);\n  color: var(--accent-primary);\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.theme-2 .icon-next {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `ThreadButton__container-fdd1eb`,
	"text": `ThreadButton__text-e3cf3e`,
	"icon": `ThreadButton__icon-be24d9`,
	"icon-mention": `ThreadButton__icon-mention-ba5280`,
	"iconMention": `ThreadButton__icon-mention-ba5280`,
	"theme-1": `ThreadButton__theme-1-ffb180`,
	"theme1": `ThreadButton__theme-1-ffb180`,
	"icon-next": `ThreadButton__icon-next-d1951e`,
	"iconNext": `ThreadButton__icon-next-d1951e`,
	"theme-2": `ThreadButton__theme-2-cb5ba8`,
	"theme2": `ThreadButton__theme-2-cb5ba8`,
	"icon-thread": `ThreadButton__icon-thread-c2a46e`,
	"iconThread": `ThreadButton__icon-thread-c2a46e`,
	"icon-unread": `ThreadButton__icon-unread-fbb139`,
	"iconUnread": `ThreadButton__icon-unread-fbb139`
};
module.exports = ___CSS_LOADER_EXPORT___;
